const cartreducer = (state = [], action) => {
  switch (action.type) {
    case "ADD_TO_CART": {
      const addItem = state.find(
        (item) => Number(item.id) === Number(action.payload.id)
      );

      if (addItem) {
        return state;
      } else {
        window.localStorage.setItem(
          "cart",
          JSON.stringify([...state, { ...action.payload, quantity: 1 }])
        );
        return [...state, { ...action.payload, quantity: 1 }];
      }
    }
    case "ADD_FROM_LOCALSTORAGE": {
      return action.payload;
    }
    case "REMOVE_FROM_CART": {
      const data = state.filter(
        (item) => Number(item.id) !== Number(action.payload)
      );
      window.localStorage.setItem("cart", JSON.stringify(data));
      return data;
    }
    case "ADD_QUANTITY_TO_PRODUCT": {
      const data = state.map((item) => {
        if (Number(item.id) === Number(action.payload.id)) {
          return { ...item, quantity: action.payload.quantity };
        }
        return item;
      });

      window.localStorage.setItem("cart", JSON.stringify(data));
      return data;
    }
    case "DECREASE_QUANTITY_FROM_PRODUCT": {
      const data = state.map((item) => {
        if (Number(item.id) === Number(action.payload.id)) {
          return { ...item, quantity: action.payload.quantity };
        }
        return item;
      });
      window.localStorage.setItem("cart", JSON.stringify(data));
      return data;
    }
    case "CART_ORDER_PLACED": {
      window.localStorage.setItem("cart", JSON.stringify([]));
      return [];
    }
    case "LOG_OUT_USER": {
      return [];
    }
    default: {
      return state;
    }
  }
};

export default cartreducer;
